import React from "react";
import { FacebookButton, TwitterButton } from "react-social";
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import styles from "./Card.module.css";

const Card = ({ children, downLoadImage, message }) => {
  const BNCL_CHART_MAPS = "https://bncllaw.com/police-violence-map/";

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        {children}
      </div>
      <div className={styles.footer}>
        <div onClick={downLoadImage} className={styles.button}>
          Download graphics
        </div>
        <div className={styles.links}>
          <div className={styles.label}>
            Share:
          </div>
          <div
            onClick={() => navigator.clipboard.writeText(BNCL_CHART_MAPS)}
            className={styles.link}
          >
            Copy link
          </div>
          <div className={styles.link}>
            <TwitterButton
              title="Share to Twitter"
              message={message}
              url={BNCL_CHART_MAPS}
              element="a"
              className=""
            >
              Share to Twitter
            </TwitterButton>
          </div>
          <div className={styles.link}>
            <FacebookButton
              title="Share via Facebook"
              message={message}
              appId={"966242223397117"}
              url={BNCL_CHART_MAPS}
              element="a"
              className=""
            >
              Share to Facebook
            </FacebookButton>
          </div>
        </div>
        <div className={styles.linksMobile}>
          <Button
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
          >
            <MoreVertIcon />
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <MenuItem onClick={handleClose}>
              <div
                onClick={() => navigator.clipboard.writeText(BNCL_CHART_MAPS)}
                className={styles.link}
              >
                Copy link
              </div>
            </MenuItem>
            <MenuItem onClick={handleClose}>
              <div className={styles.link}>
                <TwitterButton
                  title="Share to Twitter"
                  message={message}
                  url={BNCL_CHART_MAPS}
                  element="a"
                  className=""
                >
                  Share to Twitter
                </TwitterButton>
              </div>
            </MenuItem>
            <MenuItem onClick={handleClose}>
              <div className={styles.link}>
                <FacebookButton
                  title="Share via Facebook"
                  message={message}
                  appId={"966242223397117"}
                  url={BNCL_CHART_MAPS}
                  element="a"
                  className=""
                >
                  Share to Facebook
                </FacebookButton>
              </div>
            </MenuItem>
          </Menu>
        </div>
      </div>
    </div>
  );
};

export default Card;
